import "react-app-polyfill/ie11";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import ScrollToTop from "Components/ScrollToTop";

function getRenderElement(elementId: string): Element | null {
    const renderElement = document.getElementById(elementId);

    if (!renderElement) {
        console.warn(`In the html is not element #${elementId}.`);
        return null;
    } else {
        return renderElement;
    }
}

const renderElement = getRenderElement("filtr-nemovitosti");
if (renderElement) {
    ReactDOM.render(
        <BrowserRouter basename={window.rmxo_pathPrefix}>
            <ScrollToTop />
            <App />
        </BrowserRouter>,
        getRenderElement("filtr-nemovitosti")
    );
}
